import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { observer, observe } from 'redux-observers'
import { fetchCompanies } from './modules/companies'
import { fetchStatus } from './modules/status'
import { fetchTimeline } from './modules/timeline'
import rootReducer from './reducer'
import { deactivate } from './interactionReducer'
import config from '../config'

// TODO: (3) Use redux saga instead of thunk middleware for all async actions?
// https://github.com/redux-saga/redux-saga

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunkMiddleware))
)

store.dispatch(fetchCompanies())
store.dispatch(fetchStatus())
store.dispatch(fetchTimeline())

const { resetDelay } = config
let timeout
let interval

const myObserver = observer(
  state => state.system.latestInteraction,
  (dispatch, current, previous) => {
    clearTimeout(timeout)
    clearInterval(interval)
    // Start new timeout if user interacts
    if (current) {
      timeout = setTimeout(() => {
        dispatch(deactivate())
      }, resetDelay)
    }
  }
)

observe(store, [myObserver])

export default store
